import { render, staticRenderFns } from "./Admin_Integration_Virtuous_Contact.vue?vue&type=template&id=d8666966&scoped=true&"
import script from "./Admin_Integration_Virtuous_Contact.vue?vue&type=script&lang=js&"
export * from "./Admin_Integration_Virtuous_Contact.vue?vue&type=script&lang=js&"
import style0 from "./Admin_Integration_Virtuous_Contact.vue?vue&type=style&index=0&id=d8666966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8666966",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VRow,VTab,VTabItem,VTabs})
